import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    useTranslate,
    useRecordContext,
    required,
    SelectInput,
    NumberInput,
    useDataProvider,
    DataProviderContext,
} from 'react-admin';
import { Subjects } from '../../custom';
import FileUpload from '../../common/inputs/FileUpload';
import { EditToolbar } from '../../common/EditToolbar';

import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import { STATUS } from '../../common/constants';
import SlugInput from '../../common/inputs/SlugInput';
import { createCustomGoDataProvider } from '../../services';

const SubjectEdit = () => {
    let { programId, subjectId } = useParams();
    const baseDataProvider = useDataProvider();
    if (!subjectId) {
        return <LoadingSection />;
    }
    const customDataProvider = React.useMemo(
        () =>
            createCustomGoDataProvider(baseDataProvider, [
                { resource: 'subjects', apiEndpoint: `/subjects` },
            ]),
        [baseDataProvider],
    );
    return (
        <DataProviderContext.Provider value={customDataProvider}>
            <Edit
                mutationMode={'pessimistic'}
                title={<SubjectTitle />}
                redirect={() => {
                    return `programs/${programId}/subjects`;
                }}
                resource={'subjects'}
                id={subjectId}
            >
                <SimpleForm toolbar={<EditToolbar />}>
                    <FileUpload type="VIDEO_THUMBNAIL" source="image" />
                    <TextInput source="name" fullWidth validate={[required()]} />
                    <SlugInput source="slug" fullWidth />
                    <NumberInput
                        source="displayOrder"
                        type={'number'}
                        fullWidth
                        validate={[required()]}
                    />
                    <SelectInput
                        source="status"
                        label={'Status'}
                        fullWidth
                        validate={[required()]}
                        choices={STATUS}
                    />
                    <HTMLEditorInput
                        source={'description'}
                        fullWidth
                        validate={[required(), validHtml]}
                    />
                </SimpleForm>
            </Edit>
        </DataProviderContext.Provider>
    );
};

const SubjectTitle = () => {
    const record = useRecordContext<Subjects>();
    const translate = useTranslate();

    return record ? (
        <span>
            {translate('resources.subjects.name', { smart_count: 1 })} &quot;
            {record.name}&quot;
        </span>
    ) : null;
};

export default SubjectEdit;
